import React from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { Send } from "lucide-react"

const MOCK_DRIVERS = [
  {
    name: "KRSP Feliks Solovev",
    jid: "feliks.solovev@conference.demo",
    distanceKm: 30,
    remainingDrivingTime: "4h 30min",
    remainingSeconds: 16200,
    etaPickup: "24.03 09:30",
    etaDelivery: "25.03 10:15",
  },
  {
    name: "GPS4 Szymon Pietrov",
    jid: "szymon.pietrov@conference.demo",
    distanceKm: 50,
    remainingDrivingTime: "6h 15min",
    remainingSeconds: 22500,
    etaPickup: "24.03 10:00",
    etaDelivery: "25.03 10:45",
  },
  {
    name: "KR123456 Dmitry Petrov",
    jid: "dmitry.petrov@conference.demo",
    distanceKm: 72,
    remainingDrivingTime: "3h 45min",
    remainingSeconds: 13500,
    etaPickup: "24.03 10:30",
    etaDelivery: "25.03 11:15",
  },
]

/** Detect find-drivers result by matching driving times in the message body */
export function isFindDriversResult(body: string): boolean {
  const matchCount = MOCK_DRIVERS.filter((d) =>
    body.includes(d.remainingDrivingTime),
  ).length
  return matchCount >= 2
}

type FindDriversResultProps = {
  body: string
}

const FindDriversResult = ({ body }: FindDriversResultProps) => {
  const { t } = useTranslation()
  return (
    <div>
      <div className="my-3 overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                #
              </th>
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                {t("chat.findDrivers.driver")}
              </th>
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                {t("chat.findDrivers.distance")}
              </th>
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                {t("chat.findDrivers.drivingTime")}
              </th>
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                {t("chat.findDrivers.etaLoading")}
              </th>
              <th className="whitespace-nowrap px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300">
                {t("chat.findDrivers.etaUnloading")}
              </th>
              <th className="px-4 py-2.5" />
            </tr>
          </thead>
          <tbody>
            {MOCK_DRIVERS.map((driver, idx) => (
              <tr
                key={driver.name}
                className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-gray-800/50"
              >
                <td className="whitespace-nowrap px-4 py-3 text-sm tabular-nums text-gray-500 dark:text-gray-400">
                  {idx + 1}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                  {driver.name}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm tabular-nums text-gray-700 dark:text-gray-300">
                  {driver.distanceKm} km
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm tabular-nums text-gray-700 dark:text-gray-300">
                  {driver.remainingDrivingTime}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm tabular-nums text-gray-700 dark:text-gray-300">
                  {driver.etaPickup}
                </td>
                <td className="whitespace-nowrap px-4 py-3 text-sm tabular-nums text-gray-700 dark:text-gray-300">
                  {driver.etaDelivery}
                </td>
                <td className="whitespace-nowrap px-4 py-3">
                  <Button
                    size="sm"
                    variant="outline"
                    className="h-8 gap-1.5 px-3"
                  >
                    <Send className="size-3.5" />
                    {t("chat.findDrivers.send")}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default FindDriversResult
